import { useEffect, useState } from 'react'
import { routes } from 'config'
import { Link, PageProps } from 'gatsby'
import {
  Button,
  Card,
  Error as ErrorComponent,
  SEO,
  Title,
} from 'components/common'
import {
  LedgerItems,
  LedgerItemsSearch,
  LedgerItemsTable,
} from 'components/ledgers'
import {
  LedgerItemsQueryVariables,
  LedgerItemStatus,
  useLedgerItemsQuery,
} from 'lib/graphql/storeadmin'
import moment from 'moment'

export const Head = () => <SEO title="項目管理" />

const LedgerItemPage = (props: PageProps) => {
  const [searchResult, setSearchResult] = useState(null)
  const [warningMessage, setWarningMessage] = useState(null)

  const [queryVariables, setQueryVariables] =
    useState<LedgerItemsQueryVariables>({
      status: null,
      title_Contains: null,
    })
  const { data, loading, error, refetch } = useLedgerItemsQuery({
    variables: queryVariables,
  })

  useEffect(() => {
    refetch(queryVariables)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryVariables]) // deps に refetch が含まれていると、永遠に refetch し続ける

  const dataSource: Array<LedgerItems> = data?.ledgerItems?.edges?.map(
    (item) => {
      const { id, title, descriptionPlainText, status, createdAt, updatedAt } =
        item.node

      return {
        key: id,
        title: title,
        explanation: descriptionPlainText,
        status: status.toLowerCase(),
        createdAt: moment(createdAt).format('LLL'),
        updatedAt: moment(updatedAt).format('LLL'),
      }
    }
  )

  const onTabChange = (tab: LedgerItemStatus) => {
    setWarningMessage(null)
    setSearchResult(null)
    switch (tab) {
      case LedgerItemStatus.Active:
        return setQueryVariables({
          title_Contains: null,
          status: LedgerItemStatus.Active,
        })
      case LedgerItemStatus.Archived:
        return setQueryVariables({
          title_Contains: null,
          status: LedgerItemStatus.Archived,
        })
      default:
        return setQueryVariables({
          title_Contains: null,
          status: null,
        })
    }
  }

  const onSearch = () => {
    if (!searchResult) {
      setWarningMessage('絞り込みたい内容を入力してください')
      return
    }
    setWarningMessage(null)
    setQueryVariables({
      ...queryVariables,
      title_Contains: searchResult?.replace(/\s/g, ''),
    })
  }
  const searchClear = () => {
    if (searchResult !== null) {
      setWarningMessage(null)
      setSearchResult(null)
      setQueryVariables({
        ...queryVariables,
        title_Contains: null,
      })
    }
  }

  if (error) {
    return ErrorComponent.render(error)
  }

  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <Title>項目管理</Title>
        <Button type="primary">
          <Link to={routes.ledgerItemsNew}>項目を追加する</Link>
        </Button>
      </div>
      <Card
        tabList={[
          { key: 'all', tab: 'すべて' },
          { key: LedgerItemStatus.Active, tab: 'アクティブ' },
          { key: LedgerItemStatus.Archived, tab: 'アーカイブ済み' },
        ]}
        shadow
        onTabChange={onTabChange}
      >
        <LedgerItemsSearch
          onSearch={onSearch}
          searchClear={searchClear}
          setSearchResult={setSearchResult}
          searchResult={searchResult}
          warningMessage={warningMessage}
        />
        <LedgerItemsTable dataSource={dataSource || []} loading={loading} />
      </Card>
    </>
  )
}

export default LedgerItemPage
